
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const OddsAnalysisCard = () => {
  const navigate = useNavigate();

  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <div className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-blue-600" />
          <CardTitle>Betting Odds Analysis</CardTitle>
        </div>
        <CardDescription>
          Analyze betting odds and outcomes
        </CardDescription>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="space-y-4 flex-1">
          <p className="text-sm text-gray-600">
            Breakdown of match outcomes by B365 odds ranges to identify betting patterns and potential value.
          </p>
          
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Home odds success rates by range</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Draw and away win percentages</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="h-5 w-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Filter by country, league and season</span>
            </li>
          </ul>
        </div>
        
        <Button 
          onClick={() => navigate('/odds-analysis')}
          className="mt-4 w-full"
        >
          Open Odds Analysis
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default OddsAnalysisCard;
